// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TenantRead } from "./TenantRead";
import {
  TenantReadFromJSON,
  TenantReadFromJSONTyped,
  TenantReadToJSON,
  TenantReadToJSONTyped,
} from "./TenantRead";

/**
 *
 * @export
 * @interface PageTenantRead
 */
export interface PageTenantRead {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<TenantRead>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageTenantRead interface.
 */
export function instanceOfPageTenantRead(value: object): value is PageTenantRead {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageTenantReadFromJSON(json: any): PageTenantRead {
  return PageTenantReadFromJSONTyped(json, false);
}

export function PageTenantReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PageTenantRead {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(TenantReadFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageTenantReadToJSON(json: any): PageTenantRead {
  return PageTenantReadToJSONTyped(json, false);
}

export function PageTenantReadToJSONTyped(
  value?: PageTenantRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(TenantReadToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
